"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
/**
 * Utility hook that will remember previous result and
 * return it next time when next data are being fetched.
 *
 * The function to retrieve stashed data is returned which initially will
 * return `null` until some data are fetched for the first time.
 *
 * Function is always recreated so don't use it as dependency for effects,
 * memo or callbacks, use it in outer scope and depend on data directly.
 *
 * The resolver function needs to be supplied which gets `data` and should either return
 * whole `data` (the `RM.identity` is really useful) or directly select some field.
 * The resolver is executed only when `data` is available thus no checks are necessary.
 *
 * Optionally, second argument `shouldSkip` can be specified denoting that query was skipped.
 * That will forcefully clear previous cache and return `null`.
 *
 * @param loading
 * @param data
 */
function useLoadingStash(loading, data) {
    var cached = react_1.default.useRef(null);
    var buildResult = function (resolver, shouldSkip) {
        if (shouldSkip === void 0) { shouldSkip = false; }
        if (shouldSkip) {
            cached.current = null;
            return null;
        }
        if (loading) {
            return cached.current;
        }
        else if (data === undefined) {
            return null;
        }
        else {
            var next = resolver(data);
            cached.current = next;
            return next;
        }
    };
    return buildResult;
}
exports.useLoadingStash = useLoadingStash;
//# sourceMappingURL=useLoadingStash.js.map